export default __webpack_public_path__ + "static/media/Warmup Track Athletics4.9cb07ef8.jpg";